import React, { useState } from 'react';
import { useLingui } from '@lingui/react/macro';

import Search from '@rover/icons/svg/search.svg';
import { Box, Text } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';
import LocationInput from '@rover/react-lib/src/containers/LocationInputContainer';

import { LocationData, LocationInputProps } from './PlatformLocationInputInterface';

const PlatformLocationInputWeb: React.FC<LocationInputProps> = ({
  inputValue,
  onChange,
  errorMessage,
  setValue,
}) => {
  const { t } = useLingui();
  const [controlledInputValue, setControlledInputValue] = useState<string | undefined>(undefined);
  const [hasTyped, setHasTyped] = useState<boolean>(false);
  const theme = useTheme();

  const handleInputChange = (data): void => {
    if (data) {
      const locationData: LocationData = {
        value: data.value || '',
        address: data.value || '',
        latitude: Number(data.lat),
        longitude: Number(data.lng),
        postalCode: data.postalCode || '',
        countryCode: data.countryCode || '',
        city: data.city || '',
      };
      onChange(locationData);
    }
    setHasTyped(false);
  };

  const handleBlur = (): void => {
    if (hasTyped) {
      setControlledInputValue('');
      setValue('addressLine1', '');
    }
  };

  const handleOnInputChange = (value: string): void => {
    setHasTyped(true);
    setControlledInputValue(value);
  };

  return (
    <Box>
      <Text size="200" mb="3x" fontWeight="semibold">
        {t`Address`} *
      </Text>
      <LocationInput
        inputHeight="48px"
        enableLatLng
        inputValue={inputValue}
        onChange={handleInputChange}
        onInputChange={handleOnInputChange}
        onBlur={handleBlur}
        controlledInputValue={controlledInputValue}
        placeholder={t`Enter street address`}
        validationType="inline"
        renderIcon={() => <Search height={theme.space['5x']} />}
        renderIconAlignment="right"
        includeHomeAddress={false}
        validationError={errorMessage}
      />
    </Box>
  );
};

export default PlatformLocationInputWeb;
